import { render, staticRenderFns } from "./buttons-arrow.vue?vue&type=template&id=756a6313&scoped=true"
import script from "./buttons-arrow.vue?vue&type=script&lang=js"
export * from "./buttons-arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a6313",
  null
  
)

export default component.exports